/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Ledger_Col_StatusInputs */

const en_mk_sec_pg_ledger_col_status = /** @type {(inputs: Mk_Sec_Pg_Ledger_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const id_mk_sec_pg_ledger_col_status = /** @type {(inputs: Mk_Sec_Pg_Ledger_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Mk_Sec_Pg_Ledger_Col_StatusInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_ledger_col_status = /** @type {((inputs?: Mk_Sec_Pg_Ledger_Col_StatusInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Ledger_Col_StatusInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_ledger_col_status(inputs)
	return en_mk_sec_pg_ledger_col_status(inputs)
});